export default __webpack_public_path__ + "static/media/haubentaucher.6352577e.jpg";